import { DEFAULT_BALANCE_MAP } from '@interlayer/js/app/components/main/Balance/constants';
import { TBalanceType } from '@interlayer/js/app/components/main/Balance/types';
import { useDynamicTags } from '@interlayer/js/app/hooks/useDynamicTags';
import { DYNAMIC_TAG_NAMES } from '@interlayer/js/app/utils/constants';

export const useBalanceNameList = (): TBalanceType[] => {
    const [dTagAvailableBalances] = useDynamicTags([DYNAMIC_TAG_NAMES.availableBalances]);

    return (dTagAvailableBalances?.split(',') || DEFAULT_BALANCE_MAP || []) as TBalanceType[];
};
